export default class Modal {
    element;
    /**
     * @param modalElement - The modal element or a querySelector
     */
    constructor(modalElement) {
        if (typeof modalElement === 'string') {
            const element = document.querySelector(modalElement);
            if (!element) {
                throw new Error(`Failed to find an element using the selector '${modalElement}'.`);
            }
            this.element = element;
        }
        else {
            this.element = modalElement;
            if (!(this.element instanceof HTMLElement)) {
                throw new Error(`Invalid HTMLElement provided: '${modalElement ? modalElement.tagName : modalElement}'.`);
            }
        }
        // Setup event listeners
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                this.close();
            }
        });
    }
    /**
     * Opens a modal.
     */
    open() {
        this.element.classList.add('is-opened');
        this.element.setAttribute('aria-hidden', 'false');
        return this;
    }
    /**
     * Closes a modal.
     */
    close(options) {
        const modalContainer = this.element.querySelector('.modal-container');
        if (options?.isSuccess) {
            this.element.classList.add('is-success');
        }
        setTimeout(() => {
            this.element.setAttribute('aria-hidden', 'true');
        }, 50);
        const handler = (event) => {
            if (event.srcElement === modalContainer) {
                this.element.classList.remove('is-opened');
                this.element.classList.remove('is-success');
                this.element.removeEventListener('transitionend', handler, false);
            }
        };
        this.element.addEventListener('transitionend', handler, false);
        return this;
    }
    /**
     * Shakes a modal.
     */
    shake() {
        this.element.classList.add('is-shaking');
        const handler = () => {
            this.element.classList.remove('is-shaking');
            this.element.removeEventListener('animationend', handler, false);
        };
        this.element.addEventListener('animationend', handler, false);
        return this;
    }
    /**
     * Toggles a modal's state.
     */
    toggle() {
        if (this.element.classList.contains('is-opened')) {
            this.close();
        }
        else {
            this.open();
        }
        return this;
    }
    static open(selector) {
        const modal = new Modal(selector);
        modal.open();
        return modal;
    }
    static close(selector) {
        const modal = new Modal(selector);
        modal.close();
        return modal;
    }
    static shake(selector) {
        const modal = new Modal(selector);
        modal.shake();
        return modal;
    }
    static toggle(selector) {
        const modal = new Modal(selector);
        modal.toggle();
        return modal;
    }
}
window.hatchery = window.hatchery ?? {};
window.hatchery.modals = window.hatchery.modals ?? {};
if (window.hatchery.modals.initialized !== true) {
    ['open', 'close', 'toggle'].forEach(action => {
        const attribute = `data-modals-${action}`;
        document.querySelectorAll(`[${attribute}]`).forEach(el => {
            el.addEventListener('click', () => {
                let elementSelector = el.getAttribute(attribute);
                if (elementSelector?.[0] !== '#') {
                    // Prefix id selector if needed
                    elementSelector = `#${elementSelector}`;
                }
                const modal = new Modal(elementSelector);
                modal[action]();
                if (action === 'close') {
                    const event = new CustomEvent('modal-closed', {
                        detail: {
                            selector: elementSelector,
                        },
                    });
                    window.dispatchEvent(event);
                }
            });
        });
    });
}
